module.exports = __webpack_public_path__ + "img/front cover.c51a4ba5.jpg";